import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=bb99b5f0&scoped=true"
import script from "./EditInfo.vue?vue&type=script&lang=js"
export * from "./EditInfo.vue?vue&type=script&lang=js"
import style0 from "./EditInfo.vue?vue&type=style&index=0&id=bb99b5f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb99b5f0",
  null
  
)

export default component.exports